<template lang="pug">
.v-swiper-slider.swiper-slider
	swiper.swiper-slider__slider(:modules="modules"
			:navigation="navigation"
			:pagination="pagination"
			:direction="direction"
			:scrollbar="scrollbar"
			:initial-slide="options.initialSlide || 0"
			:breakpoints="options.breakpoints || null"
			:slides-per-view="options.slidesPerView || 1"
			:loop="options.loop || false"
			:space-between="options.spaceBetween || 20"
			:a11y="options.a11y"
			@swiper="onSwiper"
			@init="onInit"
			@slide-change="onSlideChange")
		slot
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';
// Swiper docs: https://swiperjs.com/vue
import { Navigation, Pagination, Scrollbar, A11y, Thumbs, EffectFade, } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default {
	components: {
		Swiper,
		SwiperSlide
	},

	emits: [
		'slide-change',
		'swiper',
		'emit'
	],

	props: {
		options: {
			type: Object,
			default: null
		},

		navigation: {
			type: [Boolean, Object],
			default: true
		},

		pagination: {
			type: Object,
			default: {
				el: null
			}
		},

		direction: {
			type: String,
			default: 'horizontal'
		},

		scrollbar: {
			type: Object,
			default: {
				el: null
			}
		}
	},

	data() {
		return {
			uniqueId: uniqueId('swiper-slider-'),
			swiper: null, // swiper instance
			modules: [
				Navigation,
				Pagination,
				Scrollbar,
				Thumbs,
				EffectFade,
				A11y
			]
		};
	},

	methods: {
		onInit() {
			this.$emit('emit');
		},

		onSwiper(swiper) {
			this.swiper = swiper;
			this.$emit('swiper', swiper);
		},

		onSlideChange(e) {
			this.$emit('slide-change', e);
		},

		slideTo(index) {
			this.swiper.slideTo(index);
		},

		slideNext() {
			this.swiper.slideNext();
		},

		slidePrev() {
			this.swiper.slidePrev();
		}
	}
};
</script>